export const translations = {
  pt: {
    nav: { home: "Início", about: "Sobre", treatments: "Tratamentos", results: "Resultados", pricing: "Preços", contact: "Contato", blog: "Caderno de Beleza", book: "Agendar", tagline: "Estética Facial e Corporal" },
    hero: {
      eyebrow: "Studio Carolina Aguiar — Bagneux · Paris",
      title_line1: "Beleza",
      title_line2: "Com Propósito",
      subtitle: "Estética avançada, cuidado personalizado e resultados que valorizam a sua beleza.",
      cta: "Agendar Horário",
      quote: "Confiança que transforma, beleza que empodera.",
      side_line1: "Mais que estética,",
      side_line2: "autoconfiança.",
      usp: [
        { t: "Tratamentos", d: "de alta performance" },
        { t: "Atendimento", d: "personalizado" },
        { t: "Resultados", d: "reais e naturais" },
      ],
    },
    usp: ["Soins Visage", "Soins Corps", "Jato de Plasma", "Anti-Idade", "Drenagem Linfática", "Bem-Estar"],
    about: {
      eyebrow: "Sobre Carolina",
      title: "Uma expertise a serviço da beleza",
      text: "Profissional de saúde no Brasil, Carolina Aguiar transformou o rigor clínico em uma arte estética sob medida.",
      signature: "Carolina Aguiar",
      role: "Profissional de Saúde & Esteticista",
      stat_number: "+1000",
      stat_label: "clientes acompanhadas",
      cta: "A história completa",
      full_title: "O percurso de Carolina",
      full_p1: "Antes de fundar seu próprio estúdio, Carolina Aguiar construiu uma sólida carreira como profissional de saúde no Brasil — a base técnica que hoje sustenta cada protocolo com segurança e precisão.",
      full_p2: "Instalada em Bagneux, ela recebe com horários flexíveis e atendimento a domicílio, unindo a excelência brasileira à sofisticação francesa.",
      values_title: "Valores",
      values: [
        { t: "Segurança clínica", d: "Protocolos de enfermagem em cada procedimento." },
        { t: "Sob medida", d: "Um plano único para cada pele." },
        { t: "Tecnologia", d: "Equipamentos de ponta, resultados visíveis." },
      ],
    },
    treatments: {
      eyebrow: "Tratamentos",
      title: "Sete protocolos de exceção",
      subtitle: "Cada sessão, uma sessão de 2 horas dedicada a você.",
      duration_label: "2h",
      book: "Agendar",
      page_title: "Tratamentos",
      page_subtitle: "Da depilação a laser aos cuidados faciais mais avançados.",
      view: "Ver",
    },
    results: {
      eyebrow: "Resultados",
      title: "Transformações que falam por si",
      subtitle: "Antes e depois reais, protocolos seguros.",
      before: "Antes", after: "Depois",
      cta: "Ver todos",
      page_title: "Resultados",
      page_subtitle: "Transformações reais, alcançadas com protocolos personalizados.",
      testimonials_title: "Vozes de clientes",
    },
    pricing: {
      eyebrow: "Investimento",
      title: "Preços & Pacotes",
      subtitle: "Sessões individuais ou pacotes vantajosos.",
      from: "a partir de",
      pacotes_title: "Pacotes — Depilação a Laser",
      sessions: "sessões", total: "total",
      book: "Agendar",
      note: "Valores sujeitos a avaliação prévia. Pagamento online em breve.",
    },
    contact: {
      eyebrow: "Contato",
      title: "Vamos cuidar da sua beleza",
      subtitle: "Escreva-nos ou agende diretamente.",
      name: "Nome completo", email: "E-mail", whatsapp: "WhatsApp", message: "Mensagem", send: "Enviar",
      hours_title: "Horários", address_title: "Endereço",
      success: "Mensagem enviada!",
      newsletter_title: "Newsletter",
      newsletter_desc: "Dicas de beleza, direto no seu e-mail.",
      newsletter_placeholder: "Seu e-mail",
      newsletter_cta: "Assinar",
      newsletter_success: "Inscrição confirmada!",
    },
    footer: {
      hours_line1: "Segunda à Sexta, 9h às 19h",
      hours_line2: "Horários flexíveis e atendimento a domicílio",
      address: "Bagneux, França",
      rights: "Todos os direitos reservados.",
      legal: "Termos legais", privacy: "Privacidade",
      tagline: "Confiança que transforma, beleza que empodera.",
    },
    blog: {
      eyebrow: "Editorial",
      title: "Caderno de Beleza",
      subtitle: "Histórias e conselhos de beleza.",
      read_more: "Ler", back: "Voltar",
      view_all: "Ver todos os artigos",
    },
    booking: {
      title: "Agendar", step1: "O tratamento", step2: "Data & horário", step3: "Seus dados",
      select_service: "Selecione um tratamento", next: "Próximo", back: "Voltar",
      select_date: "Escolha uma data", select_slot: "Horários disponíveis",
      no_slots: "Nenhum horário disponível nesta data.",
      first_name: "Nome", last_name: "Sobrenome", email: "E-mail", whatsapp: "WhatsApp", notes: "Observações (opcional)",
      confirm: "Confirmar",
      success_title: "Pedido enviado",
      success_desc: "Seu pedido está aguardando a confirmação da Carolina. Você receberá um e-mail assim que ele for confirmado.",
      whatsapp_cta: "Falar no WhatsApp",
      close: "Fechar",
      duration_note: "Cada sessão dura 2 horas.",
    },
    common: { loading: "Carregando...", error: "Ocorreu um erro. Tente novamente.", required: "Campo obrigatório" },
  },
  fr: {
    nav: { home: "Accueil", about: "À propos", treatments: "Soins", results: "Résultats", pricing: "Tarifs", contact: "Contact", blog: "Le Carnet Beauté", book: "Réserver", tagline: "Esthétique Visage & Corps" },
    hero: {
      eyebrow: "Studio Carolina Aguiar — Bagneux · Paris",
      title_line1: "La Beauté",
      title_line2: "Révélée",
      subtitle: "Esthétique avancée, soin personnalisé et des résultats qui révèlent votre beauté.",
      cta: "Prendre Rendez-vous",
      quote: "Une confiance qui transforme, une beauté qui révèle.",
      side_line1: "Plus que de l'esthétique,",
      side_line2: "de la confiance.",
      usp: [
        { t: "Soins", d: "haute performance" },
        { t: "Accueil", d: "personnalisé" },
        { t: "Résultats", d: "réels et naturels" },
      ],
    },
    usp: ["Soins Visage", "Soins Corps", "Jet de Plasma", "Anti-Âge", "Drainage Lymphatique", "Bien-Être"],
    about: {
      eyebrow: "À propos de Carolina",
      title: "Une expertise au service de la beauté",
      text: "Professionnelle de la santé au Brésil, Carolina Aguiar a transformé la rigueur clinique en un art esthétique sur mesure.",
      signature: "Carolina Aguiar",
      role: "Professionnelle de la Santé & Esthéticienne",
      stat_number: "+1 000",
      stat_label: "clientes accompagnées",
      cta: "Toute l'histoire",
      full_title: "Le parcours de Carolina",
      full_p1: "Avant de fonder son propre studio, Carolina Aguiar a construit une solide carrière de professionnelle de la santé au Brésil — le socle technique qui fonde aujourd'hui chaque protocole, en sécurité et en précision.",
      full_p2: "Installée à Bagneux, elle reçoit avec des horaires flexibles et un service à domicile, alliant l'excellence brésilienne à la sophistication française.",
      values_title: "Valeurs",
      values: [
        { t: "Sécurité clinique", d: "Des protocoles infirmiers à chaque soin." },
        { t: "Sur mesure", d: "Un plan unique pour chaque peau." },
        { t: "Technologie", d: "Des équipements de pointe, des résultats visibles." },
      ],
    },
    treatments: {
      eyebrow: "Soins",
      title: "Sept protocoles d'exception",
      subtitle: "Chaque séance, deux heures dédiées à vous.",
      duration_label: "2h",
      book: "Réserver",
      page_title: "Nos Soins",
      page_subtitle: "De l'épilation laser aux soins du visage les plus avancés.",
      view: "Voir",
    },
    results: {
      eyebrow: "Résultats",
      title: "Des transformations qui parlent",
      subtitle: "Avant/après réels, protocoles sûrs.",
      before: "Avant", after: "Après",
      cta: "Voir tout",
      page_title: "Résultats",
      page_subtitle: "Des transformations réelles, obtenues avec des protocoles personnalisés.",
      testimonials_title: "Paroles de clientes",
    },
    pricing: {
      eyebrow: "Investissement",
      title: "Tarifs & Forfaits",
      subtitle: "Séances à l'unité ou forfaits avantageux.",
      from: "à partir de",
      pacotes_title: "Forfaits — Épilation Laser",
      sessions: "séances", total: "total",
      book: "Réserver",
      note: "Tarifs soumis à évaluation préalable. Paiement en ligne bientôt disponible.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Prenons soin de votre beauté",
      subtitle: "Écrivez-nous ou réservez directement.",
      name: "Nom complet", email: "E-mail", whatsapp: "WhatsApp", message: "Message", send: "Envoyer",
      hours_title: "Horaires", address_title: "Adresse",
      success: "Message envoyé !",
      newsletter_title: "Newsletter",
      newsletter_desc: "Des conseils beauté, directement dans votre boîte mail.",
      newsletter_placeholder: "Votre e-mail",
      newsletter_cta: "S'abonner",
      newsletter_success: "Inscription confirmée !",
    },
    footer: {
      hours_line1: "Lundi à Vendredi, 9h à 19h",
      hours_line2: "Horaires flexibles et service à domicile",
      address: "Bagneux, France",
      rights: "Tous droits réservés.",
      legal: "Mentions légales", privacy: "Confidentialité",
      tagline: "Une confiance qui transforme, une beauté qui révèle.",
    },
    blog: {
      eyebrow: "Éditorial",
      title: "Le Carnet Beauté",
      subtitle: "Histoires et conseils beauté.",
      read_more: "Lire", back: "Retour",
      view_all: "Voir tous les articles",
    },
    booking: {
      title: "Réserver", step1: "Le soin", step2: "Date & créneau", step3: "Vos coordonnées",
      select_service: "Sélectionnez un soin", next: "Suivant", back: "Retour",
      select_date: "Choisissez une date", select_slot: "Créneaux disponibles",
      no_slots: "Aucun créneau disponible à cette date.",
      first_name: "Prénom", last_name: "Nom", email: "E-mail", whatsapp: "WhatsApp", notes: "Remarques (optionnel)",
      confirm: "Confirmer",
      success_title: "Demande envoyée",
      success_desc: "Votre demande est en attente de confirmation par Carolina. Vous recevrez un e-mail dès qu'elle sera confirmée.",
      whatsapp_cta: "Discuter sur WhatsApp",
      close: "Fermer",
      duration_note: "Chaque séance dure 2 heures.",
    },
    common: { loading: "Chargement...", error: "Une erreur est survenue. Veuillez réessayer.", required: "Champ requis" },
  },
};
